import { Component, OnInit, TemplateRef } from '@angular/core';
import { AppMessageService } from '../../shared/app-message/app-message.service';
import { AppMessage } from '../../shared/app-message/app-message';
import { BaseComponent } from '../../components/general/base/base.component';
import { LandingPageTile } from '../../shared/tiles/home-tile.model';
import { SidebarService } from '../../shared/sidebar/sidebar.service';

@Component({
  selector: 'qm-sidebar-panel',
  template: '',
  styles: []
})
export class SidebarPanelComponent extends BaseComponent implements OnInit {

  protected componentName: string = 'UNDEFINED';

  constructor(protected appMessageService: AppMessageService, protected sidebarService?: SidebarService) {
    super();
    this.name = this.componentName;
    console.log('Init ' + this.name);
  }

  public static initTile(tile: LandingPageTile) {
    console.log('SUPER Init tile');
    tile.description = 'UNDEFINED';
    tile.icon = 'UNDEFINED';
    tile.title = 'UNDEFINED';
    tile.panel = 'UNDEFINED';
  }

  ngOnInit() {
  }

  protected emitTitleChange(title: string, template?: TemplateRef<void>, panel: string = this.name) {
    this.sidebarService.titleChange.emit({title, template, panel});
  }

  public clearAlerts() {
    this.appMessageService.broadcastAlarm(new AppMessage(false, '', 'clear', this.componentName));
  }
}
